import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2110ece2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
import { useRouter } from "vue-router";
import domain from "@/service/domain";
import { onBeforeMount } from "vue";
export default {
  setup(__props) {
    let list = [{
      name: "立规公示",
      father_id: "3",
      son_id: "99",
      type: "divider"
    }, {
      name: "用户注册协议",
      father_id: "3",
      son_id: "1"
    }, {
      name: "隐私政策",
      father_id: "3",
      son_id: "4"
    }, {
      name: "用户注销协议",
      father_id: "3",
      son_id: "12"
    }, {
      name: "摩点社区公约",
      father_id: "2",
      son_id: "8",
      type: "divider"
    }, {
      name: "发起者协议",
      father_id: "3",
      son_id: "2"
    }, {
      name: "支持者协议",
      father_id: "3",
      son_id: "3"
    }, {
      name: "结算及退款流程",
      father_id: "3",
      son_id: "5"
    }, {
      name: "退款说明",
      father_id: "3",
      son_id: "15",
      type: "divider"
    }, {
      name: "众筹资质要求",
      father_id: "2",
      son_id: "6"
    }, {
      name: "众筹项目安全交付指南",
      father_id: "2",
      son_id: "10",
      type: "divider"
    }, {
      name: "摩点商城商家入驻协议",
      father_id: "4",
      son_id: "3"
    }, {
      name: "商家入驻保证金管理规则",
      father_id: "4",
      son_id: "8"
    }, {
      name: "摩点商城用户服务协议",
      father_id: "4",
      son_id: "19"
    }, {
      name: "摩点商城店铺命名规则",
      father_id: "4",
      son_id: "6"
    }, {
      name: "摩点商城商家售后服务管理规则",
      father_id: "4",
      son_id: "17"
    }, {
      name: "七天无理由退换货管理规则",
      father_id: "4",
      son_id: "7"
    }, {
      name: "摩点商城禁发商品信息管理规范",
      father_id: "4",
      son_id: "4"
    }, {
      name: "摩点动态使用规则",
      father_id: "4",
      son_id: "12"
    }, {
      name: "摩点商城保质期商品管理规则",
      father_id: "4",
      son_id: "13"
    }, {
      name: "摩点商城食品类目商品纠纷处理规则",
      father_id: "4",
      son_id: "15"
    }, {
      name: "POP店铺优惠券设置规则",
      father_id: "4",
      son_id: "9"
    }, {
      name: "POP商家发货操作规则",
      father_id: "4",
      son_id: "10"
    }, {
      name: "POP商家商品上传规则",
      father_id: "4",
      son_id: "11"
    }, {
      name: "电商商城商品主图及详情页规范",
      father_id: "4",
      son_id: "16",
      type: "divider"
    }, {
      name: "众筹协议I（个人愿望类）",
      father_id: "3",
      son_id: "6"
    }, {
      name: "众筹协议III（动物求助类）",
      father_id: "3",
      son_id: "11"
    }, {
      name: "云养计划用户协议",
      father_id: "3",
      son_id: "10"
    }, {
      name: "关于《电子商务法》的重要提示",
      father_id: "2",
      son_id: "9"
    }, {
      name: "摩点定向营销服务协议",
      father_id: "3",
      son_id: "13"
    }, {
      name: "抽奖活动管理规范",
      father_id: "3",
      son_id: "14",
      type: "divider"
    }];
    onBeforeMount(() => {
      document.title = '条款和协议';
    });
    const router = useRouter();
    function goProtocal(item) {
      let url = `/protocal/${item.father_id}/${item.son_id}`;
      if (item.son_id == '99') {
        url = `/protocal/rule/${item.father_id}/${item.son_id}`;
      }
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}${url}`,
        webFun: () => {
          router.push({
            path: url,
            query: {}
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
          return _openBlock(), _createBlock(_component_van_cell, {
            key: index,
            title: item.name,
            "is-link": "",
            class: _normalizeClass(item.type == 'divider' ? 'divider-item' : ''),
            onClick: $event => goProtocal(item)
          }, null, 8, ["title", "class", "onClick"]);
        }), 128))]),
        _: 1
      })]);
    };
  }
};